module.exports = __webpack_public_path__ + "img/activities-fest.ce58d15c.jpg";